import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import InstantCheckoutWrapper from './Components/InstantCheckout/InstantCheckout';
import ThdCreditCardWrapper from './Components/ThdCreditCard/ThdCreditCard';
import SaveThdCardWrapper from './Components/SaveThdCreditCard/SaveThdCreditCard';

export default class MyAccount extends Component {
  render() {
    return (
      <Router>
        <Route path="/account/view/instantcheckout"  component={InstantCheckoutWrapper} />
        <Route path="/account/view/consumercreditcard" component = {ThdCreditCardWrapper} />
        <Route path="/account/view/thdcreditcard" component = {ThdCreditCardWrapper} />
        <Route path="/account/view/savecardtoprofile" component = {SaveThdCardWrapper} />
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js